/**
 * Birth date from Mexican CURP (18) or RFC persona física (13).
 * Digits at positions 5–10 (1-based) = YYMMDD.
 * @returns {string|null} dd/mm/yyyy or null
 */
export function birthdateFromCurpOrRfc(value) {
    const s = String(value || '').toUpperCase().replace(/[^A-Z0-9Ñ&]/g, '')
    if (s.length < 10) {
        return null
    }

    const yy = parseInt(s.slice(4, 6), 10)
    const mm = parseInt(s.slice(6, 8), 10)
    const dd = parseInt(s.slice(8, 10), 10)

    if (Number.isNaN(yy) || Number.isNaN(mm) || Number.isNaN(dd) || mm < 1 || mm > 12 || dd < 1 || dd > 31) {
        return null
    }

    let century = 1900
    if (s.length >= 18) {
        // CURP: char 17 (1-based) — digit = 1900s, letter = 2000s
        const centuryChar = s.charAt(16)
        century = /[A-ZÑ]/.test(centuryChar) ? 2000 : 1900
    } else {
        const currentYY = new Date().getFullYear() % 100
        century = yy > currentYY ? 1900 : 2000
    }

    const year = century + yy
    const date = new Date(year, mm - 1, dd)
    if (date.getFullYear() !== year || date.getMonth() !== mm - 1 || date.getDate() !== dd) {
        return null
    }

    const pad = (n) => String(n).padStart(2, '0')
    return `${pad(dd)}/${pad(mm)}/${year}`
}

/** Prefer CURP, fall back to RFC. */
export function birthdateFromIds(curp, rfc) {
    return birthdateFromCurpOrRfc(curp) || birthdateFromCurpOrRfc(rfc)
}
